$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  if (p == 'organizer_promo_code' && a == 'list') {
    let promo_code_modal_lock = false;

    $(document).on('click', '#promo-code-new-button', function () {
      if ($('#promo-code-registration-form-modal').length) {
        $('#promo-code-registration-form-modal').remove();
      }
      let locationId = $('body').attr('event_id');
      getPromoCodeModal(locationId);
    });

    $(document).on('click', '.promo-code-update-button', function () {
      if ($('#promo-code-registration-form-modal').length) {
        $('#promo-code-registration-form-modal').remove();
      }
      let locationId = $('body').attr('event_id');
      let promoCodeId = $(this).attr('data-promo-code-id');
      getPromoCodeModal(locationId, promoCodeId);
    });

    function getPromoCodeModal(locationId, promoCodeId = null) {
      if ($('#product-group-registration-form-modal').length) {
        $('#product-group-registration-form-modal').remove();
      }

      if (!promo_code_modal_lock) {
        promo_code_modal_lock = true;
        $.ajax({
          type: 'POST',
          url: '/ajax/organizer_promo_code/get_modal',
          data: {
            location_id: locationId,
            promo_code_id: promoCodeId,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $('#content').append(data.html);
              $('#promo-code-registration-form-modal').modal('show');
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
            promo_code_modal_lock = false;
          })
          .always(function () {
            promo_code_modal_lock = false;
          });
      }
      return false;
    }
  }
});
